import { Component, OnInit, ViewChild } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { GeneralService } from '../services/general.service';
import { DateService } from '../services/date.service';
import { HttpClient } from '@angular/common/http';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import * as globalUrls from '../services/globalVariables';
@Component({
  selector: 'app-action-prestation',
  templateUrl: './action-prestation.component.html',
  styleUrls: ['./action-prestation.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' })
      ),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ActionPrestationComponent implements OnInit {
  row;
  oldId = { currentTarget: { style: '' } };
  numero: number;
  intutile: string;
  client: string;
  manager: string;
  debut: string;
  fin: string;
  public url = globalUrls.urlActionListDDF;
  public urlD = globalUrls.urlListActionD;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public generalService: GeneralService,
    public dateService: DateService,
    public http: HttpClient
  ) {
    this.dataSource = new MatTableDataSource();
  }
  data;
  dataD;
  dataSource;
  date_Debut;
  date_Fin;
  exist: boolean = true;
  disableBtnSupprimer: boolean = false;
  @ViewChild('listeComponen', { static: false })
  listeComponen: AvtListesComponent;
  typeAction: string;
  column = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_Code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_Intitule',
        Lg_Code: '',
        TableRD_Des: 'Intutilé',
        TableRD_Largeur: 350,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      // {"TableRE_Code":"","TableRD_Champs":"NbCmd",          "Lg_Code":"","TableRD_Des":"N.BC",    "TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":1,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {
        TableRE_Code: '',
        TableRD_Champs: 'Date_Create',
        Lg_Code: '',
        TableRD_Des: 'D.création',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Tiers_NomPublic',
        Lg_Code: '',
        TableRD_Des: 'Client',
        TableRD_Largeur: 250,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'NbCollaborateur',
        Lg_Code: '',
        TableRD_Des: 'N.Coll',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_dateDeb',
        Lg_Code: '',
        TableRD_Des: 'Debut',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 4,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtAction_dateFin',
        Lg_Code: '',
        TableRD_Des: 'Fin',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 5,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  // la fenetre liste action peut etre ouvert par le composons avtDocumentComponont pour rechercher une action
  // dans se k il faus masquer les bouton modifier et consuter
  showButton: boolean = true;
  ngOnInit() {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth() - 6);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
    this.date_Fin.setMonth(this.date_Fin.getMonth() + 6);
    this.date_Fin.setDate(1);
    this.readParamUrl();
  }
  // cette evennement pour utile pour la recherche d'un document
  // elle est utiliser par dotre composons
  choisirAction() {
    if (this.listeComponen.row != null) {
      this.generalService.actionChoisie = this.listeComponen.row;
      this.generalService.dialog.closeAll();
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }
  exportToExcel() {
    this.generalService.exportToExcel(this.listeComponen, 'LISTE ACTIONS');
  }
  modifier(typeTrs: string) {
    if (typeTrs == '1') {
      this.generalService.popupCenter(
        '/w/avt/action/1' + '/' + this.typeAction + '/' + typeTrs
      );
      return;
    }
    if (this.listeComponen.row != null) {
      this.generalService.popupCenter(
        '/w/avt/action/' +
          this.listeComponen.row.avtAction_Code +
          '/' +
          this.typeAction +
          '/' +
          typeTrs
      );
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }

  supprimer() {
    if (this.listeComponen.row != null) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(
            this.listeComponen.row.avtAction_Code,
            'avtaction'
          );
          if (deleteFn != null) {
            this.exist = false;
            this.disableBtnSupprimer = true;
            deleteFn.subscribe(
              (data) => {
                this.afficher();
                this.generalService.dialogSuccess('Elément supprimer', true);
                this.exist = true;
                this.disableBtnSupprimer = false;
              },
              (error) => {
                this.generalService.dialogSuccess(
                  'Elément non supprimé',
                  false
                );
                this.exist = true;
                this.disableBtnSupprimer = false;
              }
            );
          }
        }
        if (result == 'annuler') {
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veillez sélectionner une ligne',
        false
      );
  }

  afficher() {
    this.exist = false;
    var url =
      this.url +
      this.dateService.setFormatDateRechercheServer(this.date_Debut) +
      ',' +
      this.dateService.setFormatDateRechercheServer(this.date_Fin) +
      ',' +
      this.typeAction;
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.listeComponen.setDataSource(data);
      this.exist = true;
    });
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.typeAction = params['typeAction'];
      if (!this.generalService.isNotEmpty(this.typeAction)) {
        this.showButton = false;
        this.typeAction = this.generalService.fenetreTypeAction;
      }
      this.afficher();
    });
  }
}
